import dytMulSearch from './dyt-mulSearch.vue';

export default dytMulSearch;
